import { useEffect, type RefObject } from 'react'

/**
 * Mark a subtree `inert` while a condition holds.
 *
 * React 18 has no `inert` prop (it landed in 19), so the attribute is set directly. `aria-hidden`
 * alone is not enough on a panel that stays mounted: it hides the subtree from assistive tech while
 * leaving its buttons in the tab order, so a keyboard user can focus a control a screen reader says
 * does not exist. `inert` removes both together.
 */
export function useInert(ref: RefObject<HTMLElement | null>, isInert: boolean) {
  useEffect(() => {
    const node = ref.current
    if (!node) return
    if (isInert) node.setAttribute('inert', '')
    else node.removeAttribute('inert')
  }, [ref, isInert])
}
